var position = {
    name:null,
    /*
        * string event
        * string name
        **/
    construct: function(event, name){
        position.name = name;

        $(event).click(function(){
            position.set();
        });

        position.move();
    },

    set: function(){
        var date = new Date();
        date.setTime(date.getTime() + (3 * 1000));
        $.cookie(position.name, $(window).scrollTop(), { expires: date });
    },
    get: function(){
        return $.cookie(position.name);               
    } , 
    exist: function(){
        if(position.get() >= 0) return true;
        return false;
    },
    move: function(){
        if(position.exist()) $(window).scrollTop(position.get());
        else position.set();
    }
};